import BaseFormatter from './base'
import { has, humanFileSize } from '../../helpers'

/**
 * Format report response data for MS Office file details page
 */
export default class UnknownFileTypeDetailsFormatter extends BaseFormatter {
  /**
   * Format original report data
   *
   * @param data
   * @param report
   */
  format(data: { [key: string]: any }, report: { [key: string]: any }): void {
    const resource = this.getResource(data, 'file')
    if (!resource || typeof data.file === 'undefined') {
      return
    }

    const keys = Object.keys(report)
    const checkKey = '_details'

    // Check if other details exist
    for (let i = 0; i < keys.length; i++) {
      const pos = keys[i].indexOf(checkKey)
      if (pos > 0 && pos === keys[i].length - checkKey.length) {
        return
      }
    }

    const details: { [key: string]: any } = {}
    const copyField = ['exifMetaData', 'chmMetaData']
    copyField.forEach((field) => {
      if (typeof resource[field] !== 'undefined') {
        details[field] = resource[field]
      }
    })

    if (resource.extendedData) {
      this.copyGrouped(resource.extendedData, details)
      this.normalizeAudioData(resource.extendedData, details)
    }

    if (!Object.keys(details).length) {
      return
    }

    if (typeof report.details === 'undefined') {
      report.details = details
    } else {
      report.details = { ...report.details, ...details }
    }
  }

  /**
   * Just copy data that is pregrouped to result report
   *
   * @param data
   * @param result
   */
  copyGrouped(data: { [key: string]: any }, result: { [key: string]: any }): void {
    const names: { [key: string]: any } = {
      streams: 'oleStreams',
      pickle: 'ficklingData',
    }

    Object.entries(names).forEach(([name, mapped]) => {
      if (has(data, name)) {
        result[mapped] = data[name]
      }
    })
  }

  /**
   * Just copy data that is pregrouped to result report
   *
   * @param data
   * @param result
   */
  normalizeAudioData(data: { [key: string]: any }, result: { [key: string]: any }): void {
    // Check for audio temp (mp3 file type)
    if (data.audioMetadata && data.audioDetails) {
      result.audioMetadata = {}

      Object.entries(data.audioMetadata).forEach(([key, value]: [string, any]) => {
        if (typeof value === 'number') {
          switch (key) {
            case 'fileSize':
              value = humanFileSize(value)
              break
            case 'sampleRate':
              value = `${value} Hz`
              break
            case 'bitRate':
              value = `${value} bps`
              break
            case 'duration':
              value = `${Math.round(value)}s`
              break
            default:
              break
          }
        }

        result.audioMetadata[key] = value
      })

      Object.entries(data.audioDetails).forEach(([audioType, { present, ...details }]: [string, any]) => {
        if (present) {
          result[audioType] = details
        }
      })
    }
  }
}
